import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Row, Col } from "antd";
import GrantScheduleCard from "./GrantScheduleCard";
import {
  GrantsTable,
  UnderlyingContent,
  GrantScheduleTableFooter,
  TableLabel,
  ItemHeading
} from "../../style";
import { formatAmount } from "../../../../../../utils/commonUtil";
import { CapsuleButton } from "../../../../../..//CommonComponents/Commons/commonComponents"


const frequencyMapping = {
  Monthly: 1,
  Quarterly: 3,
  Semiannually: 6,
  Annually: 12
};

const calScheduledDate = (date, monthsToAdd) => {
  return moment(date)
    .add(monthsToAdd, "M")
    .format("MM/DD/YYYY");
};

function GrantScheduleTable({
  grantName,
  amount,
  frequency,
  startDate,
  noOfPayments,
  removeSpawn,
  addSpawn,
  showActions,
  showFooter,
  grantNameLabel = "Grant Name",
  grantAmountLabel = "Grant Amount",
  dateLabel = "Scheduled issue date",
  Table = GrantsTable,
  scroll,
  style,
  grantNameWidth = "33%"
}) {
  const columnConfig = [
    {
      title: grantNameLabel,
      dataIndex: "grantName",
      key: "grantName",
      width: grantNameWidth,
      render: (value, record) => <TableLabel tableFont>{value}</TableLabel>
    },
    {
      title: grantAmountLabel,
      dataIndex: "amount",
      key: "amount",
      render: (value, record) => <TableLabel tableFont>{formatAmount(value)}</TableLabel>
    },
    {
      title: dateLabel,
      dataIndex: "scheduledDate",
      key: "scheduledDate",
      render: (value, record) => <TableLabel tableFont>{value}</TableLabel>
    }
  ];
  if (showActions) {
    columnConfig.push({
      title: "",
      key: "action",
      className: "right-align",
      render: (value, record, index) => {
        if (noOfPayments > 2 && index + 1 === parseInt(noOfPayments, 10)) {
          return (
            <UnderlyingContent id="anrRemove"tableFont onClick={removeSpawn}>Remove</UnderlyingContent>
          );
        }
        return null;
      }
    });
  }

  const scheduleArr = [];
  const frequencyStamp = frequencyMapping[frequency];
  let totalAmount = 0;
  for (let i = 0; i < noOfPayments; i++) {
    totalAmount += parseFloat(amount);
    scheduleArr.push({
      grantName: `${grantName} | ${i + 1}`,
      amount,
      scheduledDate: calScheduledDate(startDate, i * frequencyStamp)
    });
  }

  return (
    <>
      <Row>
        <Table
          scroll={scroll}
          style={style}
          dataSource={scheduleArr}
          columns={columnConfig}
          pagination={false}
          className="hide-only-sm hide-scroll"
        />
        <Col sm={24} lg={0} md={0}>
          <GrantScheduleCard
            data={scheduleArr}
            showActions={showActions}
            noOfPayments={noOfPayments}
            removeSpawn={removeSpawn}
            grantAmountLabel={grantAmountLabel}
            dateLabel={dateLabel}
          />
        </Col>
      </Row>
      {showFooter && (
        <GrantScheduleTableFooter>
          <Row>
            <Col md={8} xs={12}>
              <TableLabel>Total</TableLabel>
            </Col>
            <Col md={4} xs={12}>
              <ItemHeading>{formatAmount(totalAmount)}</ItemHeading>
            </Col>
            <Col
              md={{ span: 4, offset: 8 }}
              xs={{ span: 20, offset: 2 }}
              className="add-grant-button-wrap"
            >
              {showActions && (
                <CapsuleButton
                  text="Add Grant"
                  iconType="add"
                  id="btnAddGrant"
                  onClick={addSpawn}
                  alt = "add icon"
                />
              )}
            </Col>
          </Row>
        </GrantScheduleTableFooter>
      )}
    </>
  );
}

GrantScheduleTable.propTypes = {
  grantName: PropTypes.string,
  amount: PropTypes.string,
  frequency: PropTypes.string,
  startDate: PropTypes.string,
  noOfPayments: PropTypes.number,
  removeSpawn: PropTypes.func,
  addSpawn: PropTypes.func,
  showActions: PropTypes.bool,
  showFooter: PropTypes.bool,
  grantNameLabel: PropTypes.string,
  grantAmountLabel: PropTypes.string,
  dateLabel: PropTypes.string,
  scroll: PropTypes.object,
  style: PropTypes.any,
  grantNameWidth: PropTypes.string
}

export default GrantScheduleTable;
